import { Box, Typography } from "@mui/material";
import { Title, useCanAccess, useTranslate } from "react-admin";

import { RequirePermission } from "../../components/RequirePermission";
import { ResourceName } from "../../constants/resources";
import { DhlAccountSettings } from "./DhlAccountSettings";
import { DhlShippingSettings } from "./DhlShippingSettings";

export const DhlSettingsPage = () => {
  const translate = useTranslate();
  const shipping = useCanAccess({ action: "list", resource: ResourceName.LogisticsDhlShippingSettings });
  const account = useCanAccess({ action: "list", resource: ResourceName.LogisticsDhlAccountSettings });
  return (
    <RequirePermission permission={ResourceName.LogisticsDhlSettings}>
      <Box sx={{ maxWidth: 720, margin: "auto", mt: 3 }}>
        <Title title={translate("dhlSettings.title")} />
        <Typography component="h1" variant="h4" gutterBottom>
          {translate("dhlSettings.title")}
        </Typography>
        {!shipping.isPending && shipping.canAccess === true && <DhlShippingSettings />}
        {!account.isPending && account.canAccess === true && (
          <Box sx={{ mt: 3 }}>
            <DhlAccountSettings />
          </Box>
        )}
      </Box>
    </RequirePermission>
  );
};
